import { Tween } from "@westpierstudio/luma/createjs";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Container, Graphics, Text } from "pixi.js";

export class NoBonusMessage extends View {
    private spec: any;

    private container: Container;
    private background: Graphics;
    private noBonusText: Text;
    private noBonusSubtext: Text;

    private currentCoinsPerBet: number = 88;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, layout, resources} = this.services;
        this.spec = resources.getSpec(`nobonusmessage`);

        this.container = factory.createContainer({alpha: 0}, this);

        this.background = new Graphics();
        this.background.alpha = this.spec.backgroundAlpha;
        this.container.addChild(this.background);

        this.noBonusText = factory.createText(resources.getMessage(`noBonus`), this.spec.noBonusText, this.container);
        this.noBonusSubtext = factory.createText(resources.getMessage(`noBonusSubtext`), this.spec.noBonusSubtext, this.container);

        this.resize();
        layout.onResize.add(() => this.resize());
    }

    display(coinsPerBet: number): void {

        if (coinsPerBet === this.currentCoinsPerBet) { return; }

        this.currentCoinsPerBet = coinsPerBet;

        this.updateMessages();

        Tween.removeTweens(this.container);
        this.container.alpha = 0;

        Tween.get(this.container).to({alpha: 1}, 500)
        .wait(2000)
        .to({alpha: 0}, 500);
    }

    disappear(): void {

        if (this.container.alpha <= 0.5) { return; }

        Tween.removeTweens(this.container);
        Tween.get(this.container).to({alpha: 0}, 250);
    }

    updateMessages(): void {

        if (this.currentCoinsPerBet === 48) {

            this.noBonusText.text = this.services.resources.getMessage(`noBonus`);
            this.noBonusSubtext.text = this.services.resources.getMessage(`noBonusSubtext`);
        } else {

            this.noBonusText.text = this.services.resources.getMessage(`bonusEnabled`);
            this.noBonusSubtext.text = ``;
        }
    }

    private resize(): void {

        const {width, height, top, left} = this.services.layout.getScreenBoundaryInBucketSpace();
        const centre = {width: left + width / 2, height: top + height / 2};

        this.background.clear();

        this.background.beginFill(this.spec.backgroundColour);
        this.background.drawRect(left, top, width, height);
        this.background.endFill();

        this.noBonusText.x = centre.width;
        this.noBonusText.y = centre.height;

        this.noBonusSubtext.x = centre.width;
        this.noBonusSubtext.y = centre.height + 18;
    }

    override reset(): void {
        Tween.removeTweens(this.container);
        this.container.alpha = 0;
        this.currentCoinsPerBet = 88;
    }
}